import React from 'react';
import { connect } from 'react-redux';
import styles from './Common.module.css'
import { SpecialTestCervicalDeepNeckFlexorEndurance } from './SpecialTestCervicalDeepNeckFlexorEndurance'
import { SpecialTestCervicalDeepNeckFlexorStrengthTest } from './SpecialTestCervicalDeepNeckFlexorStrengthTest'
import { SpecialTestCervicalMyelopathyCPRAgeGT45 } from './SpecialTestCervicalMyelopathyCPRAgeGT45';
import { SpecialTestClosedCervicalFractureCPRAgeLT55 } from './SpecialTestClosedCervicalFractureCPRAgeLT55';
import { SpecialTestLumbarInstabilityCPRAgeLT40 } from './SpecialTestLumbarInstabilityCPRAgeLT40';
import { SpecialTestSpinalStenosisCPRAgeGT48 } from './SpecialTestSpinalStenosisCPRAgeGT48';
import { SpecialTestHearingLossRineetest } from './SpecialTestHearingLossRineetest';
import { SpecialTestHearingLossWeberTest } from './SpecialTestHearingLossWeberTest';
import { SpecialTestRotatorCuffTearCluster } from './SpecialTestRotatorCuffTearCluster';
import { SpecialTestHipLegLength } from './SpecialTestHipLegLength';
import { SpecialTestSynergiesRUE } from './SpecialTestSynergiesRUE';
import { SpecialTestSynergiesLUE } from './SpecialTestSynergiesLUE';
import { SpecialTestSynergiesRLE } from './SpecialTestSynergiesRLE';
import { SpecialTestSynergiesLLE } from './SpecialTestSynergiesLLE';
import { SpecialTestMuscleToneRUpperTrunk } from './SpecialTestMuscleToneRUpperTrunk';
import { SpecialTestMuscleToneLUpperTrunk } from './SpecialTestMuscleToneLUpperTrunk';
import { SpecialTestMuscleToneRLowerTrunk } from './SpecialTestMuscleToneRLowerTrunk';
import { SpecialTestMuscleToneLLowerTrunk } from './SpecialTestMuscleToneLLowerTrunk';
import { SpecialTestCognitionShortTermMemory } from './SpecialTestCognitionShortTermMemory';
import { SpecialTestCognitionLongTermMemory } from './SpecialTestCognitionLongTermMemory';
import { SpecialTestCognitionRancho } from './SpecialTestCognitionRancho';
import { SpecialTestCoordinationDysmetria } from './SpecialTestCoordinationDysmetria';
import { SpecialTestCoordinationHeelShin } from './SpecialTestCoordinationHeelShin';
import { SpecialTestCoordinationAsiodochokinesis } from './SpecialTestCoordinationAsiodochokinesis';
import { SpecialTestCoordinationThumbFingerTouching } from './SpecialTestCoordinationThumbFingerTouching';
import { SpecialTestCoordinationFingerToNose } from './SpecialTestCoordinationFingerToNose';
import { SpecialTestRightingReactionsStrategy } from './SpecialTestRightingReactionsStrategy';
import { SpecialTestPelvicFloorAssessmentOrganProlapse } from './SpecialTestPelvicFloorAssessmentOrganProlapse';
import { SpecialTestPositionalTestingCanL } from './SpecialTestPositionalTestingCanL';
import { SpecialTestPositionalTestingCanR } from './SpecialTestPositionalTestingCanR';
import { SpecialTestPositionalTestingDixL } from './SpecialTestPositionalTestingDixL';
import { SpecialTestPositionalTestingDixR } from './SpecialTestPositionalTestingDixR';
import { SpecialTestSensationMonofilament } from './SpecialTestSensationMonofilament';
import { SpecialTestCTSIB } from './SpecialTestCTSIB';
import { SpecialTestGazeStabilization } from './SpecialTestGazeStabilization';

const components = {
    SpecialTestCervicalDeepNeckFlexorEndurance,
    SpecialTestCervicalDeepNeckFlexorStrengthTest,
    SpecialTestCervicalMyelopathyCPRAgeGT45,
    SpecialTestClosedCervicalFractureCPRAgeLT55,
    SpecialTestLumbarInstabilityCPRAgeLT40,
    SpecialTestSpinalStenosisCPRAgeGT48,
    SpecialTestHearingLossRineetest,
    SpecialTestHearingLossWeberTest,
    SpecialTestRotatorCuffTearCluster,
    SpecialTestHipLegLength,
    SpecialTestSynergiesRUE,
    SpecialTestSynergiesLUE,
    SpecialTestSynergiesRLE,
    SpecialTestSynergiesLLE,
    SpecialTestMuscleToneRUpperTrunk,
    SpecialTestMuscleToneLUpperTrunk,
    SpecialTestMuscleToneRLowerTrunk,
    SpecialTestMuscleToneLLowerTrunk,
    SpecialTestCognitionShortTermMemory,
    SpecialTestCognitionLongTermMemory,
    SpecialTestCognitionRancho,
    SpecialTestCoordinationDysmetria,
    SpecialTestCoordinationHeelShin,
    SpecialTestCoordinationAsiodochokinesis,
    SpecialTestCoordinationThumbFingerTouching,
    SpecialTestCoordinationFingerToNose,
    SpecialTestRightingReactionsStrategy,
    SpecialTestPelvicFloorAssessmentOrganProlapse,
    SpecialTestPositionalTestingCanL,
    SpecialTestPositionalTestingCanR,
    SpecialTestPositionalTestingDixL,
    SpecialTestPositionalTestingDixR,
    SpecialTestSensationMonofilament,
    SpecialTestGazeStabilization,
    SpecialTestCTSIB
}


class SpecTestsCustomPanel extends React.Component {

    renderChild(name, mopno) {
        const Child = components[name];
        return Child === undefined ? <span key={name} mopno={mopno} /> : <Child key={name} mopno={mopno} includeFlags={this.props.includeFlags} />;
    }

    render() {
        return (
            <div className={styles.row}>
                {this.renderChild(this.props.panel.MOPNAME, this.props.panel.MOPNO)}
            </div>
        );
    }
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));
    let panel = state.entities.masterData.PTMASTEROBJECTIVEPANELS[ownprops.panelId];

    return {
        noteId: noteId,
        tsno: tsno,
        panel: panel,
    };
}

const connectedSpecTestsCustomPanel = connect(mapStateToProps)(SpecTestsCustomPanel);
export { connectedSpecTestsCustomPanel as SpecTestsCustomPanel };


